export const PASSWORD_MIN_LENGTH = 12;

export type PasswordRule = {
  id: string;
  label: string;
  test: (pwd: string) => boolean;
};

export const PASSWORD_RULES: PasswordRule[] = [
  { id: 'length',     label: `Au moins ${PASSWORD_MIN_LENGTH} caractères`, test: (p) => p.length >= PASSWORD_MIN_LENGTH },
  { id: 'lowercase',  label: 'Une minuscule (a-z)',                        test: (p) => /[a-z]/.test(p) },
  { id: 'uppercase',  label: 'Une majuscule (A-Z)',                        test: (p) => /[A-Z]/.test(p) },
  { id: 'digit',      label: 'Un chiffre (0-9)',                           test: (p) => /[0-9]/.test(p) },
  { id: 'special',    label: 'Un caractère spécial (!@#$…)',               test: (p) => /[^A-Za-z0-9]/.test(p) },
];

export type PasswordStrength = {
  score: number; // 0..5
  passed: Record<string, boolean>;
  valid: boolean;
  firstError: string | null;
};

export function evaluatePassword(pwd: string): PasswordStrength {
  const passed: Record<string, boolean> = {};
  let score = 0;
  let firstError: string | null = null;
  for (const rule of PASSWORD_RULES) {
    const ok = rule.test(pwd);
    passed[rule.id] = ok;
    if (ok) score += 1;
    else if (firstError === null) firstError = rule.label;
  }
  return {
    score,
    passed,
    valid: score === PASSWORD_RULES.length,
    firstError,
  };
}

export function passwordStrengthLabel(score: number): string {
  if (score <= 1) return 'Très faible';
  if (score === 2) return 'Faible';
  if (score === 3) return 'Moyen';
  if (score === 4) return 'Fort';
  return 'Très fort';
}

export function passwordStrengthColor(score: number): string {
  if (score <= 1) return 'bg-red-500';
  if (score === 2) return 'bg-orange-500';
  if (score === 3) return 'bg-amber-500';
  if (score === 4) return 'bg-lime-500';
  return 'bg-emerald-500';
}
